import { FC, HTMLAttributes } from "react";

const getSrcSet = (src, maxWidth): string => {
  if (src.includes("?")) {
    return [48, 96, 256, 384, 460, 640, 1200, 1920, 3840]
      .map((number) => {
        if (maxWidth && number > maxWidth) {
          return null;
        }
        return `${src}&width=${number} ${number}w`;
      })
      ?.filter((d) => !!d)
      .join(",");
  }
  return [48, 96, 256, 384, 460, 640, 1200, 1920, 3840]
    .map((number) => {
      if (maxWidth && number > maxWidth) {
        return null;
      }
      return `${src}?width=${number} ${number}w`;
    })
    ?.filter((d) => !!d)
    .join(",");
};

export const Image: FC<
  {
    className?: string;
    src: string;
    alt?: string;
    srcSet?: string;
    width?: number;
    height?: number;
    maxWidth?: 48 | 96 | 256 | 384 | 460 | 640 | 1200 | 1920 | 3840;
    aspectRatio?: number;
    screenPercentage?: number;
    loading?: "eager" | "lazy";
  } & Partial<HTMLAttributes<HTMLImageElement>>
> = ({
  src,
  alt,
  className,
  width,
  height,
  aspectRatio,
  screenPercentage = 100,
  maxWidth,
  loading,
  srcSet,
  sizes,
  ...imageProps
}) => {
  if (!src) {
    return null;
  }

  if (
    /cdn\.shopify\.com\/s\/files(.*?)\/(files|products)\//gi.test(src) &&
    !window?.Shopify?.cdnHost.includes("cdn.shopify.com")
  ) {
    src = src.replace(
      /^(https?:)?\/?\/?cdn\.shopify\.com\/s\/files(.*?)\/(files|products)\//gi,
      `//${window.Shopify.cdnHost}/shop/$3/`
    );
  }

  src = src
    .replace(/&(width|height)=\d+(&)/gi, "$1")
    .replace(/\?(width|height)=\d+(&)/gi, "?")
    .replace(/\?(width|height)=\d+$/gi, "");

  // @ts-ignore
  return (
    <img
      src={
        width
          ? src.includes("?")
            ? `${src}&width=${Math.round(width)}`
            : `${src}?width=${Math.round(width)}`
          : maxWidth
          ? src.includes("?")
            ? `${src}&width=${Math.round(maxWidth)}`
            : `${src}?width=${Math.round(maxWidth)}`
          : src
      }
      alt={alt}
      width={maxWidth && maxWidth < width && aspectRatio ? maxWidth : width}
      height={
        maxWidth && maxWidth < width && aspectRatio ? Math.round(maxWidth * aspectRatio) : height
      }
      data-loading={loading}
      loading={loading}
      className={className}
      sizes={sizes}
      srcSet={getSrcSet(src, maxWidth)}
      // @ts-ignore
      style={{ objectPosition: "50% 50%", ...(imageProps?.style ?? {}) }}
      {...imageProps}
    />
  );
};
